import axios from 'axios';

// 从ie下载pdf
export const downLoadPdfFromIE = (url, fileName) => {
  axios.get(url, {
    responseType: 'blob'
  }).then(res => {
    const blob = new Blob([res.data], { type: 'application/pdf;charset=utf-8' });
    window.navigator.msSaveOrOpenBlob(blob, fileName);
  }).catch(err => {
    this.$message({
      type: "error",
      message: err.Msg
    });
  });
}
let vm = null;
const sendThis = (_this)=>{
    vm = _this;
};
// 预览pdf
export const previewPdf = (url,loading,vueInstance) => {
  axios.get(url, {
    responseType: 'blob',
  }).then(res => {
    const blob = new Blob([res.data], { type: 'application/pdf;charset=utf-8' });
    const a = document.createElement("a");
    a.href = URL.createObjectURL(blob);
    a.target = "_blank";
    document.body.appendChild(a);
    a.onclick = function () {
      document.body.removeChild(a);
    };
    a.click();
    if(loading){
      loading.close()
    }
    // const url = URL.createObjectURL(blob);
    // window.open(url, "_blank");
    // setTimeout(() => {
    //     URL.revokeObjectURL(url)
    // }, 3000)//释放资源
  }).catch(err => {
    if(loading){
      loading.close()
    }
    vueInstance.$message({
      type: "error",
      message: "预览失败！"
    });
  });
}

export const previewXSl = (url, loading) => {
  axios.get(url, {
    responseType: 'blob',
  }).then(res => {
    loading.close();
    const blob = new Blob([res.data], { type: 'application/pdf;charset=utf-8' });
    if (res) {
      const workbook = XLSX.read(new Uint8Array(res.data), {
        type: "array",
      }); // 解析数据
      const worksheet = workbook.Sheets[workbook.SheetNames[0]]; // workbook.SheetNames 下存的是该文件每个工作表名字,这里取出第一个工作表
      this.excelView = XLSX.utils.sheet_to_html(worksheet); // 渲染
      this.$nextTick(function () {
        // DOM加载完毕后执行，解决HTMLConnection有内容但是length为0问题。
        this.setStyle4ExcelHtml();
      });
    } else {
      that.$notify.error({ title: "失败", message: "接口请求失败" });
      that.loading = false;
    }
  }).catch(err => {
    loading.close();
    this.$message({
      type: "error",
      message: "预览失败！"
    });
  });
}
// 下载图片或pdf
export const downloadImgOrPdf = (url, fileName) => {
  axios({
    method: 'post',
    url,
    responseType: 'blob'
  }).then(res => {
    const blob = new Blob([res.data])
    if ('download' in document.createElement('a')) { // 非IE下载
      const dlink = document.createElement('a')
      dlink.download = fileName
      dlink.style.display = 'none'
      dlink.href = URL.createObjectURL(blob)
      document.body.appendChild(dlink)
      dlink.click()
      URL.revokeObjectURL(dlink.href) // 释放URL 对象
      document.body.removeChild(dlink)
    } else { // IE10+下载
      navigator.msSaveBlob(blob, fileName)
    }
  });
}
